import {
  ResponsiveGridLayouts,
  ResponsiveGridLayoutBreakpoint,
} from '@jupiterone/jupiter-web-toolkit';
import uuidV4 from 'uuid/v4';
import { InsightsBoard, Widget } from '../types';

import InsightsDashboards from '@jupiterone/insights-dashboards';

interface ExternalBoardJSON {
  widgets?: Widget[];
  layouts?: ResponsiveGridLayouts;
}

export const configureBoardForUse = (
  boardJSON: ExternalBoardJSON
): ExternalBoardJSON | undefined => {
  if (!boardJSON?.widgets || !boardJSON?.layouts) {
    return undefined;
  }

  const processedBoardJSON: ExternalBoardJSON = { ...boardJSON };

  const widgetLength = boardJSON.widgets.length;
  const widgetIds = new Array(widgetLength).fill(0).map((_) => uuidV4());

  widgetIds.forEach((widgetId, index) => {
    if (processedBoardJSON.widgets?.[index]) {
      processedBoardJSON.widgets[index]!.id = widgetId;

      if (processedBoardJSON.layouts) {
        Object.keys(processedBoardJSON.layouts).forEach(
          (layoutKey, layoutIndex) => {
            const layout =
              processedBoardJSON.layouts?.[
                layoutKey as ResponsiveGridLayoutBreakpoint
              ];

            if (layout && Array.isArray(layout) && layout.length > 0) {
              if (layout[index]) {
                layout[index].i = widgetId;
              }
              processedBoardJSON.layouts![
                layoutKey as ResponsiveGridLayoutBreakpoint
              ] = layout;
            }
          }
        );
      }
    }
  });

  return processedBoardJSON;
};

const boards: {
  DEFAULT_TEAM_BOARDS: InsightsBoard[];
  DEFAULT_TEAM_WIDGETS: Widget[][];
  DEFAULT_TEAM_WIDGETS_LAYOUTS: ResponsiveGridLayouts[];
} = {
  DEFAULT_TEAM_BOARDS: [],
  DEFAULT_TEAM_WIDGETS: [],
  DEFAULT_TEAM_WIDGETS_LAYOUTS: [],
};

Object.entries(InsightsDashboards).forEach(([boardName, board]) => {
  const boardId = uuidV4();
  const processedBoard = configureBoardForUse(board as ExternalBoardJSON);
  if (processedBoard !== undefined) {
    boards.DEFAULT_TEAM_BOARDS.push({
      id: boardId,
      name: boardName,
    });

    boards.DEFAULT_TEAM_WIDGETS.push(processedBoard.widgets as Widget[]);
    boards.DEFAULT_TEAM_WIDGETS_LAYOUTS.push(
      processedBoard.layouts as ResponsiveGridLayouts
    );
  }
});

export default boards;
